module.exports = __webpack_public_path__ + "static/media/28.f94cb224.jpg";